import { render, staticRenderFns } from "./IoColumn.vue?vue&type=template&id=4381904d&"
import script from "./IoColumn.vue?vue&type=script&lang=js&"
export * from "./IoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports